export default __webpack_public_path__ + "static/media/pilz-04.0ebf4deb.png";